import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { BaseChapterProps, BirthPlaceFieldValues, ProfileFormValues } from '@/pages/UserAccount/Profile';
import { FormHasDirtyFields } from '@/pages/UserAccount/Profile/ui/ProfilePresentational';

import { CountryDatalist, FormTextInput } from '@/shared/ui';

import BaseChapterTemplate from './BaseChapterTemplate/BaseChapterTemplate';

interface BirthPlaceProps extends BaseChapterProps {
  onSubmit: (values: ProfileFormValues) => void;
  setFormHasDirtyFields: (value: FormHasDirtyFields) => void;
  activeKey: Array<NonNullable<FormHasDirtyFields>>;
}

const birthPlaceDataFields = ['countryOfBirth', 'regionOfBirth', 'districtOfBirth', 'cityOfBirth'] satisfies Array<
  keyof BirthPlaceFieldValues
>;

export const BirthPlace: FC<BirthPlaceProps> = ({ onSubmit, onReset, setFormHasDirtyFields, activeKey }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { dirtyFields },
  } = useFormContext<ProfileFormValues>();

  const isBirthPlaceFieldsDirty = Object.keys(dirtyFields).some((key) =>
    birthPlaceDataFields.includes(key as keyof BirthPlaceFieldValues),
  );

  useEffect(() => {
    if (!isBirthPlaceFieldsDirty) return setFormHasDirtyFields(null);

    setFormHasDirtyFields('birth');
  }, [isBirthPlaceFieldsDirty]);

  useEffect(() => {
    if (!activeKey.includes('birth') && isBirthPlaceFieldsDirty) onReset();
  }, [activeKey]);

  const countryOfBirth = watch('countryOfBirth');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <BaseChapterTemplate
        fields={[
          <FormTextInput
            control={control}
            name="countryOfBirth"
            placeholder="Вкажіть країну"
            label="Країна народження"
            list="country-of-birth-list"
            transform="uppercase"
            key="countryOfBirth"
          />,
          <FormTextInput
            control={control}
            placeholder="Вкажіть область"
            name="regionOfBirth"
            label="Область народження"
            key="regionOfBirth"
            disabled={!countryOfBirth}
          />,
          <FormTextInput
            control={control}
            placeholder="Вкажіть район"
            name="districtOfBirth"
            label="Район народження"
            key="districtOfBirth"
            disabled={!countryOfBirth}
          />,
          <FormTextInput
            control={control}
            placeholder="Вкажіть населений пункт"
            name="cityOfBirth"
            label="Населений пункт народження"
            transform="uppercase"
            key="cityOfBirth"
            disabled={!countryOfBirth}
          />,
        ]}
        isDisabledSubmitAction={isBirthPlaceFieldsDirty && countryOfBirth.trim() !== ''}
        onReset={onReset}
      />
      <CountryDatalist id="country-of-birth-list" />
    </form>
  );
};
